/**
 * Holds a clinical DRAFT the voice assistant produced (currently: a
 * prescription dictated by voice) so it can be reviewed and confirmed in a
 * dedicated on-screen modal — separate from the assistant chat panel.
 *
 * Golden rule: a clinical write dictated by voice is NEVER committed blindly.
 * The assistant fills this draft; the doctor verifies the doses (voice
 * transcription can mishear "5 mg" as "50 mg") and confirms in the UI.
 */
import { create } from "zustand";

export interface PrescriptionDraftItem {
	medication_name: string;
	dosage: string;
	frequency: string;
	duration_days?: number;
	instructions?: string;
}

export interface PrescriptionDraft {
	type: "prescription";
	patient_id: string;
	patient_name: string;
	/** 'recorded' | 'nkda' | 'unrecorded' — drives the NKDA confirmation gate. */
	allergy_status: string;
	/** What the assistant heard — shown so the doctor can catch mishears. */
	dictation: string;
	items: PrescriptionDraftItem[];
	/** Non-empty only when items is empty: why nothing could be drafted. */
	reason: string;
}

interface AssistantDraftState {
	prescription: PrescriptionDraft | null;
	setPrescriptionDraft: (draft: PrescriptionDraft) => void;
	clearPrescriptionDraft: () => void;
}

export const useAssistantDraftStore = create<AssistantDraftState>((set) => ({
	prescription: null,
	setPrescriptionDraft: (draft) => set({ prescription: draft }),
	clearPrescriptionDraft: () => set({ prescription: null }),
}));
